import { useContext } from 'react';

import { getI18nData, isBrowser, LinkInterface } from '@lucid/utils';
import { graphql, useStaticQuery } from 'gatsby';
import { Drupal_Node } from 'generated/drupal-graphql';
import { LayoutContext } from '@lucid/components-react';

export const placeholderButtons: LinkInterface[] = [
  {
    title: '',
    link: {
      url: {
        path: '#1'
      }
    },
    links: [],
    type: 'primary',
    primary: true,
    isButton: true,
    isPlaceholder: true,
    entityId: 'placeholder1'
  }
];

const useNavButtons = (username?: string, shouldHideSignUpButton = false) => {
  const {
    language: { i18nKey, langPrefix }
  } = useContext(LayoutContext);
  const { drupal, i18nData } = useStaticQuery(
    graphql`
      {
        drupal {
          nodeById(id: "365") {
            entityTranslations {
              entityLanguage {
                id
              }
              entityUrl {
                path
              }
            }
          }
        }
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_nav_contact_sales
              }
            }
          }
        }
      }
    `
  );

  if (!isBrowser()) {
    return [];
  }

  const i18n = getI18nData(i18nData, i18nKey);
  const linkTranslations = drupal.nodeById.entityTranslations as Drupal_Node[];
  const translatedEntity = linkTranslations.find(
    ({ entityLanguage }) => entityLanguage?.id === langPrefix
  );
  const translatedPath = translatedEntity?.entityUrl?.path;

  const loggedInButtons: LinkInterface[] = [
    {
      title: i18n('mktg-nav-contact-sales'),
      link: {
        url: {
          path: translatedPath || '/contact/contact-sales'
        }
      },
      links: [],
      type: 'primary',
      primary: true,
      fieldBeaconElementDetail: 'contact-sales',
      entityId: 'contact-sales',
      isButton: true
    }
  ];

  const initialLoggedOutButtons: LinkInterface[] = [
    {
      title: i18n('mktg-nav-contact-sales'),
      link: {
        url: {
          path: translatedPath || '/contact/contact-sales'
        }
      },
      links: [],
      type: 'primary',
      primary: true,
      fieldBeaconElementDetail: 'contact-sales',
      entityId: 'contact-sales',
      isButton: true
    }
  ];

  let loggedOutButtons = initialLoggedOutButtons;
  if (shouldHideSignUpButton) {
    loggedOutButtons = initialLoggedOutButtons.slice(0, 1);
  }

  return username ? loggedInButtons : loggedOutButtons;
};

export default useNavButtons;
